import React, { useMemo, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';

import Header from '../../components/Header';
//import Sidebar from '../../components/Sidebar';
import AccountInfoTab from '../AccountIInfoTab';
import AccountSubscriptionsTab from '../AccountSubscriptionsTab';

import './style.scss';
import useProjectConfiguration from '../../hooks/useProjectConfiguration';
import { useAuthGuard } from '../../hooks/useAuthGuard';
import CloudpassService from '../../services/cloudpassService';
import AffiliatesService from '../../services/affiliatesService';

function MyAccountPage() {
  const [data, error, loading] = useProjectConfiguration();
  const { configState } = useAuthGuard();

  const urls = useMemo(() =>
    data?.client?.urls || { redirectLoginUrl: '' },
    [data?.client?.urls]);

  const onBackButtonClickHandler = () => {
    if (urls.redirectLoginUrl && !error && !loading) {
      // redirect by flows
      window.location.href = _checkAndRedirectUrlByFlow();
    }
  };

  const _checkAndRedirectUrlByFlow = () => {
    const jwtSession = localStorage.getItem('jwtSession');
      if (jwtSession) {
        const instance = new CloudpassService(configState?.cp!);
        const affiliatesService = new AffiliatesService();
        const oauthURL = instance.getOauth2LoginURL({
          countryCode: configState!.countryCode!,
          idpShortName: configState!.idp!,
          redirectURL: affiliatesService?.getBindingInitializationURL()!
        });
        return oauthURL;
      }

      return configState && configState.cpfiltered ? `${urls.redirectLoginUrl}?cp=${configState.cpfiltered}` : urls.redirectLoginUrl;
  };

  useEffect(() => {
    if (error?.code === 'AFF-451') {
      window.location.replace('/error/geoblocking');
    }
  }, [error?.code])

  return (
    <Container className="MyAccountPage" fluid>
      <Header onBackButtonClick={onBackButtonClickHandler} />
      <Tab.Container defaultActiveKey="subscription-tab">
        <Row className="justify-content-md-center">
          <Col xs lg={1}>
            {/* <Sidebar /> */}
          </Col>
          <Col md={{ span: 10 }}>
            <div className="MyAccountPage__details">
              <Tab.Content>
                <Tab.Pane eventKey="subscription-tab">
                  <AccountSubscriptionsTab />
                </Tab.Pane>
                <Tab.Pane eventKey="accountinfo-tab">
                  <AccountInfoTab />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Col>
          <Col xs lg={1}>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
}

export default MyAccountPage;
